<form #addApiTokenForm="ngForm" (ngSubmit)="save()">
    @let isScopeInvalid = addApiTokenForm.controls?.scope?.dirty && model.scopes.length === 0;
    @let scopeCheckboxesValidityCssClass = isScopeInvalid ? 'ng-invalid ng-dirty' : '';
    @let isDescriptionInvalid = addApiTokenForm.controls?.description?.dirty && model.description.length === 0;

    <div class="tw-mb-6">
        <label for="apiTokenScope">{{ 'adminApiTokens.addDialog.form.scopeLabel' | transloco }}<span class="tw-text-red-500">*</span></label>
        @if (isScopeInvalid) {
            <small class="tw-text-red-500 tw-pt-2 tw-block">{{'adminApiTokens.addDialog.form.scopeRequired' | transloco }}</small>
        }
        @for (scopeOption of scopeOptions; track scopeOption.value) {
            <div class="tw-mt-4" id="apiTokenScope">
                <p-checkbox [inputId]="scopeOption.value"
                            name="scope"
                            required="true"
                            [value]="scopeOption.value"
                            [(ngModel)]="model.scopes"
                            [attr.data-test]="'admin-api-tokens-scope-' + scopeOption.value + '-checkbox'"
                            [styleClass]="scopeCheckboxesValidityCssClass"
                />
                <label [for]="scopeOption.value" class="tw-ml-2 tw-mb-0"> {{ scopeOption.label }} </label>
            </div>
        }
    </div>
    <div class="tw-flex tw-flex-col tw-gap-2">
        <label class="tw-mb-0" for="description">{{ 'adminApiTokens.addDialog.form.descriptionLabel' | transloco }}<span class="tw-text-red-500">*</span></label>
        <input pInputText
               id="description"
               name="description"
               required="true"
               data-test="admin-api-tokens-description-input"
               [(ngModel)]="model.description"
        />
        @if (isDescriptionInvalid) {
            <small class="tw-text-red-500">{{ 'adminApiTokens.addDialog.form.descriptionRequired' | transloco }}</small>
        }
    </div>
    <div class="tw-flex tw-justify-end tw-pt-8">
        <p-button [label]="'adminApiTokens.addDialog.form.cancelBtnLabel' | transloco"
                  severity="secondary"
                  class="tw-mr-4"
                  data-test="admin-apiTokensDialog-cancel-button"
                  (click)="cancel()"
        />
        <p-button [label]="'adminApiTokens.addDialog.form.saveBtnLabel' | transloco"
                  severity="primary"
                  data-test="admin-apiTokensDialog-save-button"
                  type="submit"
                  [disabled]="addApiTokenForm.invalid"
        />
    </div>
</form>
